import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../Images/jadlogo1.png";
import { FaBars, FaTimes } from "react-icons/fa";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <>
      <nav
        style={{
          backgroundColor: "#f8f9fa",
          fontFamily: "'Poppins', sans-serif",
          border: "2px solid #000",
          borderRadius: "20px",
          padding: "10px 20px",
          margin: "15px auto",
          marginBottom: "30px",
          height: "70px",
          maxWidth: "1300px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        }}
        className="navbar navbar-expand-lg"
      >
        <div
          className="container-fluid d-flex justify-content-between align-items-center"
        >
          {/* Logo */}
          <a
            href="#home"
            className="navbar-brand d-flex align-items-center"
            style={{ fontWeight: "bold" }}
          >
            <img
              src={logo}
              alt="JAD Logo"
              style={{ height: "60px", marginRight: "10px" }}
            />
            
          </a>

          {/* Toggle Button */}
          <button
            className="navbar-toggler border-0"
            type="button"
            onClick={toggleMenu}
            style={{ outline: "none" }}
          >
            {isOpen ? (
              <FaTimes size={28} color="#000" />
            ) : (
              <FaBars size={28} color="#000" />
            )}
          </button>

          {/* Menu Links */}
          <div
            className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
          >
            <ul
              className="navbar-nav ms-auto text-center"
              style={{ gap: "15px", display: "flex", flexDirection: "row" }}
            >
              <li className="nav-item">
                <a
                  href="/home"
                  className="nav-link"
                  style={{
                    color: "#000",
                    fontWeight: "500",
                    transition: "0.3s",
                  }}
                  onMouseOver={(e) => (e.target.style.color = "#f6b93b")}
                  onMouseOut={(e) => (e.target.style.color = "#000")}
                >
                  HOME
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/projects"
                  className="nav-link"
                  style={{
                    color: "#000",
                    fontWeight: "500",
                    transition: "0.3s",
                  }}
                  onMouseOver={(e) => (e.target.style.color = "#f6b93b")}
                  onMouseOut={(e) => (e.target.style.color = "#000")}
                >
                  PROJECTS
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="/contact"
                  className="nav-link"
                  style={{
                    color: "#000",
                    fontWeight: "500",
                    transition: "0.3s",
                  }}
                  onMouseOver={(e) => (e.target.style.color = "#f6b93b")}
                  onMouseOut={(e) => (e.target.style.color = "#000")}
                >
                  CONTACT US
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
